import React from 'react';
import styled from '@emotion/styled';
import { semantic_colors, colors, text_styles, shapes } from '../../../foundation';
import { Stack } from '../../stack';
import { date_ragne_preset_disabled_style } from '../styles';
import { DatePreset, DatePresetItem } from './types';

export interface DateRangePresetProps {
  selected?: DatePresetItem['id'];
  items: DatePreset;
  onChange?: ({ label, range, id }: DatePresetItem) => void;
}

export const DataRangePreset = ({ selected, items, onChange }: DateRangePresetProps) => {
  return (
    <DatePresetContainer direction='column'>
      {items.map(({ label, range, id, disabled }, index) => {
        const checked = selected === id;
        return (
          <PresetButton key={index} checked={checked} css={[disabled && date_ragne_preset_disabled_style]}>
            <input type='radio' checked={checked} onChange={() => onChange?.({ label, range, id })} />
            {label}
          </PresetButton>
        );
      })}
    </DatePresetContainer>
  );
};

const DatePresetContainer = styled(Stack)`
  border-right: 1px solid ${semantic_colors.border.primary};
  padding: 8px;
`;

const PresetButton = styled.label<{ checked: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 8px 12px;
  cursor: pointer;
  width: 80px;
  height: 38px;
  vertical-align: middle;
  white-space: nowrap;
  outline: none;
  ${text_styles.Body_13_Regular};
  ${shapes.border_radius.xsmall};
  transition: all 0.1s linear;
  ${({ checked }) =>
    checked
      ? `
          background-color: ${semantic_colors.accent.primary};
          color: ${semantic_colors.content.primary_inverse};
          &:hover, &:active {
            background-color: ${semantic_colors.accent.primary};
          }
        `
      : `
          background-color: ${semantic_colors.background.surface};
          color: ${semantic_colors.content.primary};
          &:hover {
            background-color: ${semantic_colors.accent.light};
          }
          &:active {
            background-color: ${colors.blue100};
          }
        `};

  input[type='radio'] {
    display: none;
  }
`;
